import { render } from "./UpGuide.vue?vue&type=template&id=3fe948c4"
import script from "./UpGuide.vue?vue&type=script&lang=js"
export * from "./UpGuide.vue?vue&type=script&lang=js"

import "./UpGuide.vue?vue&type=style&index=0&id=3fe948c4&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1d9c808fc766473613eb0f9d559345b4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__